import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { StreamState } from './types';
import { RootState } from '@/store/types';

export const state: StreamState = {
  audioCurrentDevice: null,
  audioDevicesList: [],
  volume: 100,
  videoCurrentDevice: null,
  videoDevicesList: [],
  textToSpeechCurrentVoice: null,
  textToSpeechVoicesList: [],
  resolution: null,
  isLoading: false,
  streamChangeCount: 0,
};

const namespaced = true;

export const stream: Module<StreamState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
